import React from 'react';
export function SpanishBanner() {
  return <section className="bg-paper py-12 border-t border-concrete/30" data-id="element-277">
      <div className="container mx-auto px-8 lg:px-12 flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12" data-id="element-278">
        <h2 className="text-ink font-light text-lg md:text-xl tracking-wide m-0" data-id="element-279">
          ¡También hablamos español!
        </h2>
        <a href="https://wa.me/19548181392" className="border border-ink text-ink px-8 py-3 text-[10px] uppercase tracking-[0.2em] hover:bg-ink hover:text-paper transition-colors" data-id="element-280">
          Escríbenos
        </a>
      </div>
    </section>;
}